import React, {useEffect} from 'react';
import NavXCSI from "../../layout/respnsivenavigation/nav-xsci";
import {useLocation} from 'react-router-dom';
import FooterXsci from "../../layout/footer/footer-xsci";
import {useTranslation} from "react-i18next";
import Hero from "./hero/hero";
import KeyFeatures from "./keyfeatures/keyFeatures";
import Process from "./process/process";
import DiagonalSection from "./diagonalSection/diagonalSection";
import WhyChooseService from "./whyChooseService/whyChooseService";
import CTASection from "../webdesign/ctaSection/ctaSection";


const ServicesCustomWebDev: React.FC = () => {

    const location = useLocation();
    const { t, i18n } = useTranslation();

    const pageTitle = "Custom Web Application Development & Backend ServicesSection in Kanata - XSCI";
    const metaDescriptionContent = "XSCI offers affordable, flexible custom web application development and backend services in Kanata. Build scalable, high-performing web apps with powerful server-side functionality to grow your business. Start today!";



    useEffect(() => {
        // Change the background color when this page is loaded
        document.body.style.backgroundColor = 'white';

        // Cleanup the effect when leaving this page (optional)
        return () => {
            document.body.style.backgroundColor = ''; // Reset background color when leaving
        };
    }, [location]);


    useEffect(() => {
        document.title = pageTitle;

        // Set the meta description
        let metaDescription = document.querySelector("meta[name='description']") as HTMLMetaElement;

        // The content you're trying to use for the meta description
        const descriptionContent = metaDescriptionContent;

        if (metaDescription) {
            metaDescription.setAttribute("content", descriptionContent); // Correctly set the content
        } else {
            metaDescription = document.createElement("meta") as HTMLMetaElement;
            metaDescription.name = "description";
            metaDescription.content = descriptionContent;
            document.head.appendChild(metaDescription);
        }
    }, []);


    return (
        <>
            <NavXCSI />
            <Hero/>
            <KeyFeatures/>
            <WhyChooseService/>
            <Process/>
            <DiagonalSection/>
            <CTASection
                text={"Tell us what you’re building"}
                subText={"we’ll help you bring it to life."}/>
            <FooterXsci/>

            {/*<CenteredPageContainer component={() => (*/}
            {/*    <>*/}
            {/*        <div className={`${webdevstyles.flex_box_container_intro} ${responsive.flex_box_container_intro}`}>*/}
            {/*            <div className={`${webdevstyles.flex_item_intro1} ${responsive.flex_item_intro1}`}>*/}
            {/*                /!*<ImageOnScroll SrcImage={webdev}/>*!/*/}
            {/*                <Lazy SrcImage={webdev}/>*/}

            {/*            </div>*/}
            {/*            <div className={`${webdevstyles.flex_item_intro2} ${responsive.flex_item_intro2}`}>*/}
            {/*                <h1 style={{fontWeight: "bold"}}>{String(t('services.webApplications.introTitle'))}</h1>*/}
            {/*                {String(t('services.webApplications.introBody'))}*/}
            {/*            </div>*/}
            {/*        </div>*/}

            {/*        /!* FEATURES *!/*/}
            {/*        <h1 className={`${webdesignstyles.key_feature_title} ${responsive.key_feature_title}`}*/}
            {/*            style={{color: "black", marginTop: "120px", fontWeight: "900"}}>*/}
            {/*            {String(t('services.webDesign.keyFeatures.keyFeaturesSectionTitle'))}*/}
            {/*        </h1>*/}

            {/*        <div className={`${webdevstyles.flex_box_container} ${responsive.flex_box_container}`}>*/}
            {/*            <div className={`${webdevstyles.flex_item} ${responsive.flex_item}`}>*/}
            {/*                <div className={webdevstyles.flex_item_feature}>*/}
            {/*                    <h3 className={webdevstyles.feature_title}>{String(t('services.webApplications.keyFeatures.keyFeature1Title'))}</h3>*/}
            {/*                    {String(t('services.webApplications.keyFeatures.keyFeature1Desc'))}*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*            <div className={`${webdevstyles.flex_item} ${responsive.flex_item}`}>*/}
            {/*                <div className={webdevstyles.flex_item_feature}>*/}
            {/*                    <h3 className={webdevstyles.feature_title}>{String(t('services.webApplications.keyFeatures.keyFeature2Title'))}</h3>*/}
            {/*                    {String(t('services.webApplications.keyFeatures.keyFeature2Desc'))}*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*            <div className={`${webdevstyles.flex_item} ${responsive.flex_item}`}>*/}
            {/*                <div className={webdevstyles.flex_item_feature}>*/}
            {/*                    <h3 className={webdevstyles.feature_title}>{String(t('services.webApplications.keyFeatures.keyFeature3Title'))}</h3>*/}
            {/*                    {String(t('services.webApplications.keyFeatures.keyFeature3Desc'))}*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*            <div className={`${webdevstyles.flex_item} ${responsive.flex_item}`}>*/}
            {/*                <div className={webdevstyles.flex_item_feature}>*/}
            {/*                    <h3 className={webdevstyles.feature_title}>{String(t('services.webApplications.keyFeatures.keyFeature4Title'))}</h3>*/}
            {/*                    {String(t('services.webApplications.keyFeatures.keyFeature4Desc'))}*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*        <CTAButton content={String(t('services.webApplications.cta'))} linkTo={'/contact'} />*/}

            {/*    </>*/}
            {/*)}/>*/}

        </>
    );
};

export default ServicesCustomWebDev;
